import { ComposableFunctionArgs } from '~/composables';
import { VsfContext } from '~/composables/context';
import { Logger } from '~/helpers/logger';

export const loadTotalQtyCommand = {
  execute: async (context: VsfContext, params?: ComposableFunctionArgs<{}>) => {
    Logger.debug('[Magento]: Load cart total qty');

    const apiState = context.$magento.config.state;
    if (apiState.getCartId()) {
      const { data, errors } : any = await context.$magento.api.cartTotalQty(
        apiState.getCartId(),
        params?.customQuery ?? null,
        params?.customHeaders ?? null,
      );

      if (errors) {
        console.log('* cartTotalQty errors', errors);
        throw new Error(errors[0].message);
      }

      return data?.cart?.total_quantity ?? 0;
    }

    return 0;
  },
};
